import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ProviderWrapper from './Index/ProviderWrapper';
import Nav from './Index/Nav';
import Error from './Index/Error';
import Loading from './Index/Loading';
import { reducer, actions } from './Index/store';
import load from './Index/load';
// for backwards compatibility
import { receiveName } from './Index/store/nav/actions';

function noop() {
  return {
    type: 'ignore this action',
  };
}

export class BaseImpl extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    // TODO FIX THIS ... this.componentDidUpdate = this.componentDidMount;
    // need to check state and only reload when necessary
    // to do that we need to figure out how to correctly
    // handle request chaining
  }

  componentDidMount() {
    const token = localStorage.getItem('auth-token');
    const brandName = window.location.hostname.split('.')[0];
    const {
      initialLoad, applicationName, startupActions,
    } = this.props;
    initialLoad(token, applicationName, brandName, startupActions);
  }

  render() {
    const {
      store, onNavItem, children, applicationName,
    } = this.props;
    return (
      <ProviderWrapper
        store={store}
        alwaysRender={[
          <Error key="ProviderWrapper.Error" />,
          <Loading key="ProviderWrapper.Loading" />,
        ]}
        applicationName={applicationName}
      >
        <div style={{ position: 'fixed', zIndex: 10 }}>
          <Nav onNavItem={onNavItem} />
        </div>
        <div style={{ marginLeft: '250px' }}>{children}</div>
      </ProviderWrapper>
    );
  }
}

BaseImpl.propTypes = {
  applicationName: PropTypes.string.isRequired,
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  startupActions: PropTypes.arrayOf(PropTypes.shape({})),
  initialLoad: PropTypes.func.isRequired,
  onNavItem: PropTypes.func,
};

BaseImpl.defaultProps = {
  children: [],
  startupActions: [],
  onNavItem: () => null,
};

export function errorHandler(dispatch) {
  return (err) => {
    if (err.message?.startsWith('ResizeObserver')) {
      return true;
    }
    dispatch(actions.error.error(err));
    return false;
  };
}

export function mapDispatchToProps(dispatch) {
  let once = true;
  async function initialLoad(token, applicationName, brand, startupActions) {
    if (once) {
      once = false;
      window.addEventListener('error', errorHandler(dispatch));
      window.addEventListener('unhandledrejection', errorHandler(dispatch));
    }
    dispatch(actions.auth.receiveToken(token));
    dispatch(actions.brand.receiveBrand(brand));
    if (await dispatch(actions.user.requestUser())) {
      dispatch(actions.nav.requestNav(applicationName));
      startupActions.forEach((action) => dispatch(action()));
    }
  }
  return {
    initialLoad,
  };
}

const Base = connect(
  undefined,
  mapDispatchToProps,
)(BaseImpl);

export {
  // for backwards compatibility
  Base,
  noop as receiveToken,
  receiveName,
  // end backwards compatibility
  Base as Component,
  reducer,
  actions,
  load,
};

export default {
  Component: Base,
  reducer,
  actions,
};
